<template>
<p># of Rounds: {{round}}</p>
</template>

<script>
export default {
    props: ['round']
}
</script>

<style scoped>
p {
    text-align: center;
}
</style>